const STORAGE_KEY = 'bp_tango_scores';

export function calcCategoryStats(cardTimes, words) {
  const byCategory = {};
  for (const word of words) {
    if (cardTimes[word.id] === undefined) continue;
    if (!byCategory[word.category]) {
      byCategory[word.category] = { times: [] };
    }
    byCategory[word.category].times.push(cardTimes[word.id]);
  }
  return Object.entries(byCategory).map(([categoryId, data]) => {
    const avgTimeSec = data.times.reduce((a, b) => a + b, 0) / data.times.length / 1000;
    const stars = avgTimeSec < 2 ? 3 : avgTimeSec < 4 ? 2 : 1;
    return { categoryId, avgTimeSec, stars };
  });
}

export function calcGrade(categoryStats, wrongTaps) {
  if (categoryStats.length === 0) return 'D';
  const globalAvg = categoryStats.reduce((sum, c) => sum + c.avgTimeSec, 0) / categoryStats.length;
  const adjusted  = globalAvg + wrongTaps * 0.5;
  if (adjusted < 1.5) return 'A+';
  if (adjusted < 2.5) return 'A';
  if (adjusted < 4)   return 'B';
  if (adjusted < 6)   return 'C';
  return 'D';
}

export function calcBadges(categoryStats, wrongTaps, prevScores) {
  const badges = [];
  if (categoryStats.every(c => c.stars === 3)) badges.push('Speed Star');
  if (wrongTaps === 0) badges.push('No Mistakes');
  const prev = prevScores || {};
  const isImproving = categoryStats.some(c => {
    const p = prev[c.categoryId];
    return p && c.avgTimeSec * 1000 < p.bestAvgMs;
  });
  if (isImproving) badges.push('Improving!');
  return badges;
}

export function loadScores() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

export function saveScores(categoryStats) {
  const existing = loadScores();
  for (const cat of categoryStats) {
    const avgMs = cat.avgTimeSec * 1000;
    const prev  = existing[cat.categoryId] || {};
    existing[cat.categoryId] = {
      bestAvgMs: prev.bestAvgMs !== undefined ? Math.min(prev.bestAvgMs, avgMs) : avgMs,
      lastAvgMs: avgMs,
    };
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
}
